import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ErrorPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const error = location.state?.error;

	return (
		<div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4 w-full">
			<div className="max-w-md text-center w-full">
				<div className="bg-red-100 p-6 rounded-full flex items-center justify-center w-24 h-24 mx-auto">
					<svg
						className="w-16 h-16 text-red-500"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth={2}
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M12 9v6m0 4h.01m-6.938-2h13.856C19.062 18 20 17.062 20 15.938V8.062C20 6.938 19.062 6 17.938 6H6.062C4.938 6 4 6.938 4 8.062v7.876C4 17.062 4.938 18 6.062 18z"
						/>
					</svg>
				</div>
				<h1 className="mt-6 text-2xl font-semibold text-gray-800">
					{error}
				</h1>
				<h2 className="mt-6 text-xl font-semibold text-gray-800">
					Please get in touch with the support team.
				</h2>
				<button
					onClick={() => navigate("/login")}
					className="mt-6 bg-sky-500 text-white px-6 py-2 rounded-lg shadow hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-offset-2"
				>
					Back to login.
				</button>
			</div>
		</div>
	);
};

export default ErrorPage;
